import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseAlert } from '@app/components/common/BaseAlert/BaseAlert';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { isAdminToolSsoOnly, normalizeAdminToolSsoMode } from '@app/constants/enums/adminToolSsoMode';
import dayjs from 'dayjs';
import * as S from './TemporaryPasswordBanner.styles';

export const TemporaryPasswordBanner: React.FC = () => {
  const { t } = useTranslation();
  const userData = useAppSelector((state) => state.user.userData);
  const { currentCanton } = useAppSelector((state) => state.config);
  const ssoOnly = isAdminToolSsoOnly(normalizeAdminToolSsoMode(currentCanton?.adminToolSsoEnabled));

  const isTemporaryPasswordActive = userData?.temporary_password_active === true;
  const expiresAt = userData?.temporary_password_expires_at;

  if (!isTemporaryPasswordActive || ssoOnly) {
    return null;
  }

  const formatExpiresAt = (timestamp: string | null | undefined): string => {
    if (!timestamp) {
      return '';
    }
    try {
      return dayjs(timestamp).format('YYYY-MM-DD HH:mm');
    } catch {
      return timestamp;
    }
  };

  const expiresAtFormatted = formatExpiresAt(expiresAt);
  const message = expiresAtFormatted
    ? t('adminusers.bannerMessageWithExpiry', { expiresAt: expiresAtFormatted })
    : t('adminusers.bannerMessage');

  return (
    <S.BannerWrapper>
      <BaseAlert
        type="error"
        message={
          <S.BannerContent>
            <S.BannerText>{message}</S.BannerText>
            <S.BannerLink to="/change-password">{t('adminusers.changePasswordLink')}</S.BannerLink>
          </S.BannerContent>
        }
        showIcon
        closable={false}
      />
    </S.BannerWrapper>
  );
};
